import React from "react";
import moment from "moment";
const Timer = ({
  days,
  hours,
  minutes,
  seconds,
  startTime,
  endTime,
  difference,
}) => {
  var s = new Date(Number(startTime * 1000)).toUTCString();
  var e = new Date(Number(endTime * 1000)).toUTCString();
  // console.log(+new moment(`${s} 00:00:00`).utc() > +new Date());
  const start = +new moment(`${s}`).utc() > +new Date();

  const end = +new moment(`${e}`).utc() < +new Date();
  const dateData = [
    {
      title: "Days",
      date: days,
    },
    {
      title: "Hours",
      date: hours,
    },
    {
      title: "Minutes",
      date: minutes,
    },
    {
      title: "Seconds",
      date: seconds,
    },
  ];

  return (
    <div className="text-white mb-8">
      <h1 className="text-2xl sm:text-4xl  font-black italic text-white  text-center mb-8 uppercase ">
        {start
          ? "DBLIT Private Sale"
          : end
          ? "DBLIT Private Sale"
          : "DBLIT Private Sale"}
      </h1>
      {/*<div className="grid grid-flow-col justify-center gap-7 mt-2">
        {dateData.map((val, i) => (
          <div key={i} className="text-center">
            <p className="orange-gradient w-12 mb-1 mx-auto sm:w-14 h-12 sm:h-14 font-bold text-xl flex justify-center items-center">
              {val.date.toString().padStart(2, "0")}
            </p>
            <p className="font-normal text-center text-sm">{val.title}</p>
          </div>
        ))}
      </div>*/}
    </div>
  );
};

export default Timer;
